// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable, asyncScheduler } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { buyExam } from '../../apis/exam';
import { buyExamActions } from '../actionCreators/buyExamActions';
import { RootAction } from '../rootActionCreator';
import { ExamInformation } from '../../types/Model';

const outputActions = {
  success: buyExamActions.success,
  failure: buyExamActions.failure
};

type RequestActionTypes = ActionType<
  typeof buyExamActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const buyExamEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(buyExamActions.request)
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: false }),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, test, creditMethod, workshopId, success, onError } = action.payload;
      // send api promise
      return buyExam(id, test, creditMethod, workshopId)
        .then((response: AxiosResponse<ExamInformation>) => {
          // handle success case here
          success && success();
          return buyExamActions.success({
            examInformation: response.data
          });
        })
        .catch((error: AxiosError) => {
          const message = error.response?.data || 'Unhandled Error';
          onError && onError(message);
          return outputActions.failure({ error: message });
        })
    })
  );
};
